
export const complaintsTableConfig = () => {
    return [

        {
            id: "username",
            header: "Пользователь",
            field: "username"
        },
        {
            id: "phone",
            header: "Номер телефона",
            field: "phone",
        },
        {
            id: "email",
            header: "E-mail",
            field: "email",
        },
        {
            id: "type",
            header: "Тип жалобы",
            field: "type",
        },
        {
            id: "comment",
            header: "Комментарий",
            field: "comment",
        },
        {
            id: "date",
            header: "Дата и время",
            field: "date",
        },
        {
            id: "object",
            header: "Объект жалобы",
            field: "object",
        },
        {
            id: "status",
            header: "Статус",
            field: "Статус",
        },
    ];
}
